import './BlackMarket.css';
import { Title } from '../../components/Title/Title';
import { BigButton } from '../../components/buttons/BigButton/BigButton';
import { IcoMinus } from '../../components/svg/IcoMinus';
import { IcoPlus } from '../../components/svg/IcoPlus';

export const BlackMarket = () => {
    return (
        <div className={'market'}>
            <div className={'market__header'}>
                <Title title={'Чёрный рынок'} position={'left'}></Title>
                <BigButton classStyle={'market__button-position'} bgColor={'blue'} buttonText={'Купить скины'} icon={<IcoPlus />}></BigButton>
                <BigButton buttonText={'Продать скины'} textColor={'grey'} icon={<IcoMinus />}></BigButton>
            </div>
            <div className={'market__balance'}>
                <div>
                    <p className={'market__balance-text'}>Ваш баланс</p>
                    <div>
                        <p className={'market__balance-text market__balance-text_bold'}>
                            {' '}
                            15 067.00 p.
                            <span className={'market__balance-text'}>{`Курс: 1  поинт = 0.01$ = 0.75 ₽ `}</span>
                        </p>
                    </div>
                </div>
                <BigButton bgColor={'blue-blur'} buttonText={'Ввести промокод'} />
            </div>
        </div>
    );
};
